import * as React from 'react'
import { Form } from 'antd'
import { createSetFilterValue } from 'helpers/filters'
import { stopEvent } from 'helpers/events'
import { showError } from 'helpers/errors'
import { t } from 'helpers/i18n'
import Select, { Option } from 'elements/Select'
import { Row, Col } from 'elements/Grid'

class Filter extends React.Component {
  state = {}

  constructor(props) {
    super(props)

    this.setFilterValue = createSetFilterValue(this)
  }

  async componentDidMount() {
    try {
      const response = await this.props.getLabelTemplateTypes()

      this.setState({ labelTemplateTypes: response.value.data.items })
    } catch (error) {
      showError({ error })
    }
  }

  render() {
    const { filterDto = {} } = this.props

    return (
      <Form layout="vertical" colon={false} onSubmit={stopEvent}>
        <Row>
          <Col third>
            <Form.Item label={t('type')}>
              <Select
                onChange={(value) => this.setFilterValue('labelTemplateType', value)}
                placeholder={t('all')}
                value={filterDto.labelTemplateType}
                allowClear
              >
                {(this.state.labelTemplateTypes ?? []).map((each) => (
                  <Option key={each.labelTemplateType} value={each.labelTemplateType}>
                    {each.displayName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(Filter)
